import React from 'react';
import { PropTypes } from 'prop-types';
import { ErrorMessage } from '~/components/Form/styles';
import * as S from './styles';
import Icon from '~/components/Icon';

export default function CustomSelect({
  selector,
  label,
  value,
  onChange,
  error,
  options,
  icon,
  placeholder,
  disabled,
}) {
  return (
    <S.Container disabled={disabled}>
      <S.Label htmlFor={selector}>{label}</S.Label>
      <S.InputWrapper errorColor={error.length > 0}>
        {icon && <Icon size={22} name={icon} color="gray2" />}
        <S.Select
          classNamePrefix="select"
          id={selector}
          value={value}
          onChange={onChange}
          options={options}
          placeholder={placeholder}
          isDisabled={disabled}
        />
      </S.InputWrapper>
      <ErrorMessage shouldShow={error.length > 0}>{error}</ErrorMessage>
    </S.Container>
  );
}

CustomSelect.propTypes = {
  selector: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  error: PropTypes.string,
  options: PropTypes.array,
  icon: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

CustomSelect.defaultProps = {
  label: '',
  value: {},
  onChange: () => {},
  error: '',
  options: [],
  icon: '',
  placeholder: '',
  disabled: false,
};
